module.exports = __webpack_public_path__ + "img/meishi.0ee04427.jpg";